module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/fiascoCover_2x.aa00e73.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/fiascoCover_2x.png
// module id = BwTN
// module chunks = 41